/**
 * Image Render
 *
 * DOM rendering helpers for image picker tiles, previews, and placeholders.
 */

import { ImageUtils } from "./image-utils";
import { Roles } from "../../../constants/roles";
import { imageForm } from "./image-form";

interface RenderImageItem {
    isNew?: boolean;
    src?: string;
    url?: string;
    id?: number;
}

class ImageRender {
    public static createLoadingPlaceholder(): HTMLElement {
        const placeholder = document.createElement("div");
        placeholder.className = "picker-tile picker-loading-tile";
        placeholder.setAttribute("data-role", Roles.MEDIA_TILE);
        placeholder.innerHTML = `
            <div class="tile-loading">
                <div class="spinner"></div>
                <div class="loading-text"></div>
            </div>
        `;

        const textElement = imageForm.getLoadingText(placeholder);
        if (textElement) {
            const translation = ImageUtils.getTranslation("attachments.loading_image_short", "โหลกE..");
            textElement.textContent = translation;
        }

        return placeholder;
    }

    public static renderImageGrid(imageGrid: Element, images: RenderImageItem[], existingImagesLength = 0): void {
        imageGrid.innerHTML = "";

        images.forEach((item, index) => {
            const imageDiv = document.createElement("div");
            imageDiv.className = "picker-tile picker-tile-with-controls";
            imageDiv.setAttribute("data-role", Roles.MEDIA_TILE);

            const imageType = item.isNew ? "new" : "existing";
            imageDiv.setAttribute("data-image-type", imageType);

            if (item.isNew) {
                imageDiv.setAttribute("data-image-index", String(index - existingImagesLength));
            } else if (item.id !== undefined) {
                imageDiv.setAttribute("data-image-id", String(item.id));
            }

            imageDiv.innerHTML = `
                <img src="${item.src || item.url || ""}" alt="Preview" class="picker-image">
                <div class="picker-controls" data-role="${Roles.MEDIA_CONTROLS}">
                    <button type="button" class="picker-rotate" data-role="${Roles.MEDIA_ROTATE}" title="หมุนรูปภาพ" aria-label="หมุนรูปภาพ" tabindex="-1">
                        ↻
                    </button>
                    <button type="button" class="btn circle-clear media-picker picker-remove" data-role="${Roles.MEDIA_REMOVE}" title="ลบรูปภาพ" aria-label="ลบรูปภาพ" tabindex="-1">
                    </button>
                </div>
            `;

            imageGrid.appendChild(imageDiv);
        });
    }

    public static createRotationSpinner(): HTMLElement {
        const spinner = document.createElement("div");
        spinner.className = "tile-loading";
        spinner.innerHTML = '<div class="spinner"></div><div class="loading-text"></div>';

        const textElement = imageForm.getLoadingText(spinner);
        if (textElement) {
            const translation = ImageUtils.getTranslation("attachments.loading_rotating_short", "หมุน...");
            textElement.textContent = translation;
        }

        return spinner;
    }
}

export { ImageRender };
